import { useNavigate } from "react-router-dom";
import ArrowLeftSLineIcon from "remixicon-react/ArrowLeftSLineIcon";
import Header from "../../components/Header/Header";
import SideNavbar from "../../components/Navbar/SideNavbar";
import CreateNewTag from "../ProductTags/CreateNewTag";

const CreateTagingPage = () => {
    const navigate = useNavigate();

    const backToListing = () => navigate("/productTagging");

    return (
        <>
            <div className="flex mainWrapper w-full">
                <div className="sidenav-wrapper">
                    <SideNavbar />
                </div>
                <div className="right-container">
                    <div className="header-container">
                        <Header />
                    </div>
                    <div className="body-container">
                        <div className="Subheader bg-white p-[15px] shadow-[0_2px_6px_rgba(0,0,0,.1)]">
                            <p className="text-xl font-bold text-[#43425D] flex items-center">
                                <ArrowLeftSLineIcon onClick={backToListing} size={24} className="mr-4 cursor-pointer" />
                                Create New Tag
                            </p>
                        </div>
                        <div className="p-4">
                            <CreateNewTag productTagDetails={null} pageMode="create" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};
export default CreateTagingPage;
